<template>
  <el-container style="width: 100%;height: 100%" v-loading="firstOutLoading">

    <el-aside width="auto" style="background-color: #ffffff!important;height: 100vh;overflow: hidden">
      <results-nav :data="menuList" :analyzeId="analyzeId" :projectId="projectId" style="width: 100%" ref="resultNav"
                   v-if="isMenuState"></results-nav>
    </el-aside>
    <el-container>
      <el-header style="padding-bottom: 10px!important;height: 50px;margin-right: 20px ">
        <div style="display: flex;margin: 20px 0px;justify-content: space-between">
          <div style="display: flex;">
            <i class="el-icon-s-fold" @click="handleMenu" style="color: #5c5e5e;font-size: 20px;cursor:pointer;"
               title="收缩菜单栏" v-show="!rightMenu"></i>
            <i class="el-icon-s-unfold" @click="handleMenu" style="color: #5c5e5e;font-size: 20px;cursor:pointer;"
               title="展开单栏" v-show="rightMenu"></i>
            <el-breadcrumb separator-class="el-icon-arrow-right"
                           style="margin-top: 2px;margin-left: 20px;font-size: 16px">
              <el-breadcrumb-item>{{ firPath.substring(0, pathSplit) }}</el-breadcrumb-item>
              <el-breadcrumb-item v-if="secPath">{{
                  firPath.substring(pathSplit + 1, firPath.length)
                }}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div style="display: flex">
            <search-by-key @handleNodeClick="callNav" :menuList="menuList">
            </search-by-key>
            <el-button type="success" size="small" plain @click="preReRunAnalyze()" v-if="!isReRunAnalyze"
                       style="margin-left: 20px;height: 40px">重跑分析
            </el-button>
            <el-button type="primary" size="small" plain @click="downloadAnalyzeAll()"
                       style="margin-left: 20px;height: 40px">下载报告
            </el-button>
          </div>
        </div>
      </el-header>
      <el-main style="height: 100%;width: 100%;padding: 0px 20px;margin-top: 15px" class="contain">
        <router-view style="width: 100%" v-if="isRouterAlive" :key="$route.fullPath"/>
      </el-main>
    </el-container>
    <!--      重跑分析-->
    <re-run-analyze v-if="showReRunAnalyzeDialog" :groupSampleData="reRunGroupSample" @submitData="reRunAnalyze"
                    :analyze-id="analyzeId"></re-run-analyze>
    <el-backtop :bottom="50" :right="50" :visibility-height="20" target=".contain">
      <span style="font-size: 14px;padding: 3px">返回顶部</span>
    </el-backtop>
  </el-container>
</template>

<script>
import ResultsNav from './ResultsNav'
import { downloadProgress } from '@/mixins/downloadProgress'
import { getDataInLocalStorage, saveDataToLocalStorage } from '@/utils/localStorageUtils'
import ReRunAnalyze from '@/components/ReRunAnalyze'
import { checkReportDownload, getAnalyzeGroupSampleNames, reRunAnalyze } from '@/api/analyze/analyze'
import { downReport } from '@/utils/download'
import SearchByKey from '@/components/SearchByKey'
import { saveDataToSessionStorage } from '@/utils/sessionStorage'

const baseURL = process.env.VUE_APP_BASE_API
const maps = {
  'Correlation': {
    name: '微生物群落与代谢组关联分析',
    son: {
      'Mantel_proc': 'Manteltest和普氏分析',//1
      'Distance-decay_similarity': '距离依赖相似性',
      'Heatmap': 'Heatmap',
      'Networks': 'Network网络分析',
    }
  },
  'Biomarkers': {
    name: '',
    son: {
      'OTU': '',//1
      'Genus': '',
      'Metabolites': '',
      'Networks': 'Network网络分析',
    }
  },
}
const menuMap = new Map([
  ['Correlation', '微生物群落与代谢组关联分析'],
])
export default {
  mixins: [downloadProgress],
  components: {
    ResultsNav,
    ReRunAnalyze,
    'search-by-key': SearchByKey
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      projectId: '',
      analyzeId: '',
      showReRunAnalyzeDialog: false,
      reRunGroupSample: {},
      isRouterAlive: true,
      rightMenu: '',
      secPath: false,
      menuList: [],
      tranMenu: {},
    }
  },
  computed: {
    isMenuState () {
      return this.$store.state.rightMenu.isMenuState
    },
    firstOutLoading () {
      return this.$store.state.rightMenu.firstOutLoading
    },
    firPath () {
      if (this.$store.state.rightMenu.path) {
        return this.$store.state.rightMenu.path
      }
      return ''
    },
    dirName () {
      if (this.$store.state.rightMenu.dirName) {
        return this.$store.state.rightMenu.dirName
      }
      return ''
    },
    pathSplit () {
      if (this.firPath.includes('/')) {
        this.secPath = true
        return JSON.parse(JSON.stringify(this.firPath.lastIndexOf('/')))
      } else {
        this.secPath = false
        return this.firPath.length
      }
    },
    isReRunAnalyze () {
      return this.$store.state.rightMenu.isReRunAnalyze
    }

  },
  async created () {
    this.analyzeId = this.$route.query.analyzeId
    this.projectId = this.$route.query.projectId
    this.path = this.$route.query.path
    // this.pathSplit = JSON.parse(JSON.stringify(this.path.lastIndexOf("/")))
    await this.getDirsList()
  },
  mounted () {
    this.checkVersion()
  },
  methods: {
    downloadAnalyzeAll () {
      downReport(this.analyzeId).then(msg => {
        if (msg !== 'ok') {
          this.$messageUi.error(msg)
        }
      }).catch(err => {
        this.$messageUi.error(err)
      })

    },
    async getDirsList () {
      const res = await this.$http.get('/preview/ResultsDirectory/' + this.projectId + '/' + this.analyzeId)
      if (res.code === 200) {
        this.menuList = res.data
        let id = this.menuList.length
        console.log(this.menuList)
        let projectInformation = {
          index: 99,
          name: '00.分析详情',
          path: '',
          sons: ''
        }//分析详情
        this.menuList.map((item) => {
          var newName = menuMap.get(item.name.substring(3))
          console.log(item.name.substring(3))
          if (item.sons.length > 0) {
            item.sons.map((itemSon) => {
              console.log(itemSon)
              if (itemSon.name.substring(0, 3).lastIndexOf('.') !== -1) {
                var nameSon = maps[item.name.substring(3)].son[itemSon.name.substring(3)]
                // console.log(item.name.substring(3),itemSon.name.substring(3),maps[item.name.substring(3)])
              } else {
                var nameSon = maps[item.name.substring(3)].son[itemSon.name]
              }
              if (nameSon) {
                if (itemSon.name.substring(0, 3).lastIndexOf('.') !== -1) {
                  itemSon.name = itemSon.name.substring(0, 3) + nameSon
                } else {
                  itemSon.name = nameSon
                }

              }
            })
          }
          if (newName) {
            item.name = item.name.substring(0, 3) + newName
          }
        })
        for (let i = 0; i < this.menuList.length; i++) {
          // this.menuList[i]['name']=this.tranMenu[i]
          this.menuList[i]['index'] = i + 1
          let sonListLength = this.menuList[i].sons.length
          for (let j = 0; j < sonListLength; j++) {
            id++
            this.menuList[i].sons[j]['index'] = id
          }
        }
        this.menuList.unshift(projectInformation)
      } else {
        this.$messageUi.error(res.message)
      }
    },
    handleMenu () {
      this.rightMenu = !this.rightMenu
      this.$store.commit('changeMenu')
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    async checkVersion () {
      let analyzeSet = getDataInLocalStorage('isFirstComeAnalyze') ? new Set(JSON.parse(getDataInLocalStorage('isFirstComeAnalyze'))) : new Set([])
      let res = await this.$http.get('/analyze/checkVersion/' + this.analyzeId)
      saveDataToSessionStorage('isReRunAnalyze', res.data)
      if (!analyzeSet.has(this.analyzeId)) {
        //第一次进入该分析
        analyzeSet.add(this.analyzeId)
        saveDataToLocalStorage('isFirstComeAnalyze', JSON.stringify(Array.from(analyzeSet)))
        if (!res.data) {
          this.$confirmUi('项目的版本已发生重大改变，该分析将不提供绘图参数的修改。建议重跑该分析，若不重跑则不能在线修改绘图参数, 是否重跑该分析?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            getAnalyzeGroupSampleNames(this.analyzeId).then(data => {
              const groupSampleName = data.groupSample
              if (groupSampleName) {
                this.reRunGroupSample = data
                this.showReRunAnalyzeDialog = true
              } else {
                this.$messageUi.error('重新运行失败，获取分组名，样本名失败，请稍后再试')
              }
            }).catch(err => {
              this.$messageUi.error('重新运行失败，获取分组名，样本名失败，请稍后再试')
            })
          }).catch(() => {
            // this.$store.commit('changeIsReRunAnalyze', false)
          })
        }
      }
    },
    preReRunAnalyze () {
      getAnalyzeGroupSampleNames(this.analyzeId).then(groupSampleName => {
        if (groupSampleName) {
          this.reRunGroupSample = groupSampleName
          this.showReRunAnalyzeDialog = true
        } else {
          this.$messageUi.error('重新运行失败，获取分组名，样本名失败，请稍后再试')
        }
      }).catch(err => {
        this.$messageUi.error('重新运行失败，获取分组名，样本名失败，请稍后再试')
      })
    },
    reRunAnalyze (groupColor, analyzeId, type) {
      this.showReRunAnalyzeDialog = false
      if (type === 'confirm') {
        reRunAnalyze(groupColor, analyzeId).then(res => {
          if (res === 'success') {
            this.$messageUi.success('重新运行成功')
            this.$router.push('/analyze?projectId=' + this.projectId)
          }
        }).catch(err => {
          this.$messageUi.error('重新运行失败')
        })
      }
    },
    //点击搜索后的结果，展开对应的目录结构
    callNav (parent, son) {
      parent.search = true
      this.$refs.resultNav.handleNodeClick(parent)
      if (son) {
        this.$refs.resultNav.handleNodeClick(son)
      }
    }
  }
}
</script>

<style scoped>
.main-container {
  height: 100%;
}

.contain {
  height: 100%;
  width: 100%;
  overflow-x: hidden !important;
}
</style>
